import { useMemo } from 'react'

/**
 * Helper hook to get the environment variables, so we don't have to type their names every time.
 */
export const useEnv = () => {
  const isLocalDev = useMemo<boolean>(() => import.meta.env.VITE_LOCAL_DEV === 'true', [])
  const isKiosk = useMemo<boolean>(() => import.meta.env.VITE_ENV === 'kiosk', [])
  const isWeb = useMemo<boolean>(() => import.meta.env.VITE_ENV === 'web', [])

  return {
    isLocalDev,
    isKiosk,
    isWeb,
  }
}
